import { render, staticRenderFns } from "./MioTable.vue?vue&type=template&id=18d63f22&"
import script from "./MioTable.vue?vue&type=script&lang=js&"
export * from "./MioTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports